
import React from 'react';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface RequestsErrorStateProps {
  error: Error | null;
  onRetry: () => void;
}

const RequestsErrorState: React.FC<RequestsErrorStateProps> = ({ error, onRetry }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-red-50 p-4 rounded-lg border border-red-200">
      <div className="flex items-center gap-2 text-red-600 mb-2">
        <AlertCircle className="w-5 h-5" />
        <h3 className="font-semibold">{t('interview.loadingError')}</h3>
      </div>
      <p className="text-red-700">
        {error instanceof Error ? error.message : t('interview.unknownError')}
        {' '}
        {t('interview.pleaseTryRefreshing')}
      </p>
      <Button 
        variant="outline"
        className="mt-2"
        onClick={onRetry}
      >
        {t('interview.tryAgain')}
      </Button>
    </div>
  );
};

export default RequestsErrorState;
